module.exports = __webpack_public_path__ + "static/Crystal4-20d13b1f552e357c664ea949a97d1ec4.png";